import sleep from "sleep";
import Pin 	from "pin";
import EventTarget	from "eventtarget";

const PIN_PFO = 17; // direction: in, power good
const PIN_LIM = 22; // direction: in, Capacitor low voltage level
const PIN_SHD = 27; // direction: out, Shutdown

class Module extends EventTarget {
  constructor(...args) {    
    super(...args);

    this.id = "qUPS module";
    this.status = "uninitialized";    
    this.name = "qups";    
  }
  async initialize() {
    try {            
      this.__pin_pfo = new Pin("/sys/class/gpio", PIN_PFO);
      this.__pin_lim = new Pin("/sys/class/gpio", PIN_LIM);
      this.__pin_shd = new Pin("/sys/class/gpio", PIN_SHD);

      //TODO: modify library
      await sleep(2000);
      //await this.__pin_pfo.open("/sys/class/gpio", PIN_PFO);
      //await this.__pin_lim.open("/sys/class/gpio", PIN_LIM);
      //await this.__pin_shd.open("/sys/class/gpio", PIN_SHD);

      this.__pin_pfo.direction = 1;
      this.__pin_lim.direction = 1;
      this.__pin_shd.direction = 0;

      //signal the device that we are running
      this.__pin_shd.value = 1;  

      this.status = "OK";      
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {              
      this.__external_power = this.__pin_pfo.value;
      this.__capacitor_low = this.__pin_lim.value;

      if (this.__pin_pfo.value && this.timer) {
        this.dispatchEvent( new CustomEvent("onpower", {detail: null}) );
        if (this.timer) clearTimeout(this.timer);
        delete this.timer;
      } 
      
      if (!this.__pin_pfo.value && !this.timer) {
        this.dispatchEvent( new CustomEvent("onbattery", {detail: null}) );
        this.timer = setTimeout(function() {
          this.dispatchEvent( new CustomEvent("onshutdown", {detail: null}) );
        }.bind(this), 10000);      
      }      

      this.status = "Ok";
      //console.log(JSON.stringify(this));
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  } 
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      external_power: this.__external_power,
      capacitor_low: this.__capacitor_low
    });
  }
}

export default Module;